import { FC, useMemo } from 'react';
import ChooseMethod from '@sections/send_and_request/steps/choose_method';
import { EFundsOperation } from '@enum';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import { routes } from '@const/routes';
import { useNavigationContext } from '@hooks/context/useNavigationContext';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onChangeMethod: (val: Exclude<EFundsOperation, EFundsOperation.CARD_DEBIT_DEPOSIT>) => void;
    method: EFundsOperation;
    onSubmit: () => void;
    type: 'request' | 'send';
    styles: any;
    title: string;
}

const requestMethods: Exclude<EFundsOperation, EFundsOperation.CARD_DEBIT_DEPOSIT>[] = [
    EFundsOperation.WALLET_DEBIT_REQUEST,
    EFundsOperation.E_TRANSFER_DEBIT_REQUEST,
    EFundsOperation.EFT_DEBIT_DEPOSIT
    // TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
    // EFundsOperation.EPS_DEBIT_DEPOSIT
];

const sendMethods: Exclude<EFundsOperation, EFundsOperation.CARD_DEBIT_DEPOSIT>[] = [
    EFundsOperation.WALLET_CREDIT_TRANSFER,
    EFundsOperation.E_TRANSFER_CREDIT_TRANSFER,
    EFundsOperation.EFT_CREDIT_WITHDRAWAL
];

const ChooseMethodSection: FC<IProps> = ({ onChangeMethod, onSubmit, type, title, styles }) => {
    const { handleBack } = useNavigationContext();
    const { submitLocale } = useLocales();
    const methods = useMemo(() => (type === 'request' ? requestMethods : sendMethods), [type]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <Button
                        className={styles.back}
                        leftIcon="arrow_left"
                        variant="text-gray"
                        onClick={() => handleBack(routes.send_and_request)}>
                        {submitLocale('back')}
                    </Button>
                    <Typography variant="h4">{title}</Typography>
                </div>
                <div className={styles.cards_wrapper}>
                    {methods.map((item, i) => (
                        <ChooseMethod
                            key={i}
                            onClick={() => {
                                onChangeMethod(item);
                                onSubmit();
                            }}
                            type={item}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChooseMethodSection;
